import LiveFeedback, { useLiveNotice } from '../Manage/LiveList/Component/LiveFeedback';
import { useMemberDetails } from '../../Component/Context/MemberDetails';
import ChatModeratedText, { forbiddenChatRanges } from '../../Component/UI/ChatModeratedText';
import {

  forwardRef,
  useCallback,

  useEffect,
  useLayoutEffect,

  useImperativeHandle,

  useRef,

  useState,
  useMemo,
  ReactNode,

} from "react";

import styled from "styled-components";
import { createPortal } from "react-dom";
import axios from "axios";
import api from "../../Component/axios_Interceptor/api";

import url from "../../Component/server";

import { live_info_type } from "../User/Live/Live";
import { chatEndpoint } from "../Broadcast/chatEndpoint";
import { fitChatViewport } from "../Broadcast/fitChatViewport";
import useChatRestrictions, { ChatRestriction } from './useChatRestrictions';



export type ChatUser = { userId: string; nickname: string; restriction?: ChatRestriction | null };
export type ChatQuestion = { messageId: string; nickname: string; content: string; private: boolean };

interface ChatComponentProps {

  mesage: string; // mesage prop 추가

  all_visible?: boolean; // all_visible prop 추가

  live_info: live_info_type;
  isAuthenticated?: boolean;
  readOnly?: boolean;
  adminView?: boolean;
  renderUserActions?: (user: ChatUser) => ReactNode;
  renderReply?: (question: ChatQuestion, onClose: () => void) => ReactNode;
  answeredMessageIds?: ReadonlySet<string>;
  onPurchaseNotification?: (content: string) => void;
  searchQuery?: string;
  searchIndex?: number;
  onSearchMatches?: (count: number) => void;
  hideForbiddenMessages?: boolean;
  hideMutedMessages?: boolean;
  showNicknameSeparator?: boolean;
}



const Box = styled.div<{ $admin: boolean }>`
  box-sizing: border-box;
  display: flex;
  flex: 1 1 0;
  flex-direction: column;
  width: 100%;
  height: 100%;
  min-height: 0;
  overflow-y: auto; // 스크롤 추가
  -ms-overflow-style: none; // IE 및 Edge

  scrollbar-width: none; // Firefox

  &::-webkit-scrollbar {

    display: none; // Chrome, Safari, Opera

  }

  [data-chat-name-separator="true"]::after { content: ' : '; }
  [data-chat-content][data-chat-has-sender="true"] { margin-inline-start: var(--space-3, 12px); }
  [data-chat-name-separator="true"] + [data-chat-content] { margin-inline-start: 0; }

  ${({ $admin }) => $admin && `
    scrollbar-width: thin;
    font-family: var(--font-family-base);
    > div { font-size: var(--text-body-lg); line-height: 1.6; margin-bottom: var(--space-3); }
    > div > div { text-shadow: none; font-family: inherit; }
    [data-chat-line] { display: grid; grid-template-columns: minmax(0, 1fr) max-content; column-gap: var(--space-3); align-items: start; }
    [data-chat-body] { min-width: 0; overflow-wrap: anywhere; }
    [data-chat-meta] time { margin-left: 0; }
    [data-chat-name] { font-family: inherit; font-weight: 600; color: var(--color-text-primary); }
    [data-chat-content] { color: var(--color-text-primary); }
    [data-chat-muted="true"], [data-chat-name-muted="true"] { color: var(--color-warning); }
    [data-chat-name-forbidden="true"] { color: var(--color-chat-forbidden); text-decoration: line-through; }
    [data-chat-content-forbidden="true"] { color: var(--color-chat-forbidden); text-decoration: line-through; }
    [data-chat-type="coupon"] { color: var(--color-warning); }
    [data-chat-content][data-chat-type="manage"] { color: #ffdc6a; }
    [data-chat-side="right"] [data-chat-line] { text-align: right; }
    [data-chat-type="buy"] { color: var(--color-info); }
    [data-chat-type="system"] { color: var(--color-text-secondary); }
    [data-chat-search-match] { background: var(--color-warning-subtle); border-radius: var(--radius-md); }
    [data-private][data-chat-search-match], [data-chat-restricted][data-chat-search-match] { background: transparent; }
    mark[data-chat-search-text] { background: var(--color-warning); color: var(--color-bg-page); font: inherit; font-weight: 600; border-radius: var(--radius-sm); }
    [data-private] [data-chat-content] mark[data-chat-search-text] { color: inherit; background: var(--color-warning-subtle); }
    [data-chat-restricted] mark[data-chat-search-text] { color: inherit; background: var(--color-info-subtle); }
    [data-chat-search-active="true"] { outline: 2px solid var(--color-focus-ring); outline-offset: -2px; }
    &::-webkit-scrollbar { display: block; width: var(--space-2); }
  `}
`;

const ChatBox = styled.div`
  display: flex;
  flex: 0 0 auto;
  flex-direction: row;

  width: 100%;

  line-height: 22px;

  font-size: 15px;

  margin-bottom: 6px;

`;



const MessageLine = styled.div`

  width: 100%;

  word-break: keep-all;
  overflow-wrap: break-word;

  white-space: pre-wrap;

  text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.8);

  font-family: var(--font-Pretendard-Regular);

`;



const NameSpan = styled.span<{ $chatType: string }>`
  font-family: ${({ $chatType }) => $chatType === "system" ? "inherit" : "var(--font-Pretendard-Bold)"};
  font-weight: 600;
  color: ${(props) =>
    props.$chatType === "buy"
      ? "#54A8FF"
      : props.$chatType === "manage" || props.$chatType === "coupon"
      ? "#ffcc00"
      : props.$chatType === "system"
      ? "#EA2922"
      : "rgba(255, 255, 255, 0.85)"};

`;



const ContentSpan = styled.span<{ $chatType: string }>`
  font-weight: 400;
  color: ${(props) =>
    props.$chatType === "buy"
      ? "#54A8FF"
      : props.$chatType === "manage" || props.$chatType === "coupon"
      ? "#ffcc00"
      : props.$chatType === "system"
      ? "#EA2922"
      : "white"};

`;

const UserButton = styled.button`
  display: inline; padding: 0; border: 0; border-radius: var(--radius-sm);
  background: transparent; font: inherit; color: var(--color-text-primary); font-weight: 600; cursor: pointer;
  text-decoration: none;
  &:hover { color: var(--color-text-link); }
  &:focus-visible { outline: 2px solid var(--color-focus-ring); outline-offset: 2px; }
`;
const ChatMeta = styled.div`
  display: grid; grid-template-columns: 5ch var(--control-sm); align-items: center;
  gap: var(--space-2); white-space: nowrap;
  @media (pointer: coarse) { grid-template-columns: 5ch var(--touch-target); }
`;
const OverflowButton = styled.button`
  display: inline-flex; align-items: center; justify-content: center; flex: none;
  width: var(--control-sm); min-height: var(--control-sm); padding: 0; border: 0; border-radius: var(--radius-sm);
  background: transparent; color: var(--color-text-secondary); cursor: pointer;
  svg { width: var(--space-5); height: var(--space-5); fill: currentColor; }
  &:hover, &[aria-expanded="true"] { background: var(--color-bg-subtle); color: var(--color-text-primary); }
  &:focus-visible { outline: 2px solid var(--color-focus-ring); outline-offset: 2px; }
  @media (pointer: coarse) { min-width: var(--touch-target); min-height: var(--touch-target); }
`;
const InlineMenu = styled.div`
  position: fixed; z-index: var(--z-dropdown); display: flex; flex-direction: column; align-items: stretch; gap: var(--space-1); min-width: calc(var(--space-8) * 5); max-width: calc(100vw - var(--space-6)); box-sizing: border-box; color: var(--color-text-primary); white-space: normal;
  padding: var(--space-1); border: 1px solid var(--color-border-default); border-radius: var(--radius-md);
  background: var(--color-bg-elevated); font-size: var(--text-caption); text-shadow: none;
  && button[data-chat-action] {
    display: inline-flex; align-items: center; justify-content: flex-start; gap: var(--space-1); width: 100%; min-height: var(--control-sm);
    margin: 0; padding: 0 var(--space-3); border: 1px solid transparent; border-radius: var(--radius-md); font: inherit; font-weight: 600; cursor: pointer;
    transition: background var(--duration-fast), border-color var(--duration-fast), box-shadow var(--duration-fast);
  }
  && button[data-chat-action="block"] { background: var(--color-danger-subtle); color: var(--color-danger-strong); }
  && button[data-chat-action="mute"] { background: var(--color-warning-subtle); color: var(--color-warning); }
  && button[data-chat-action="reply"] { background: var(--color-brand-subtle); color: var(--color-text-link); }
  && button[data-chat-action="copy"] { background: var(--color-bg-subtle); color: var(--color-text-primary); }
  && [data-selected-user] { display: flex; flex-direction: column; align-items: stretch; gap: var(--space-1); }
  && button[data-chat-action="block"]:hover:not(:disabled) { background: var(--color-danger-subtle); color: var(--color-danger-strong); }
  && button[data-chat-action="mute"]:hover:not(:disabled) { background: var(--color-warning-subtle); color: var(--color-warning); }
  && button[data-chat-action]:hover:not(:disabled) { border-color: currentColor; box-shadow: inset 0 0 0 1px currentColor; }
  && button[data-chat-action="reply"]:hover { background: var(--color-brand-hover); color: var(--color-text-on-brand); }
  && button[data-chat-action]:focus-visible { outline: 2px solid var(--color-focus-ring); outline-offset: 2px; }
  && button[data-chat-action]:disabled { background: var(--color-bg-muted); color: var(--color-text-disabled); cursor: not-allowed; }
  @media (pointer: coarse) { && button[data-chat-action] { min-width: var(--touch-target); min-height: var(--touch-target); } }
`;
const ReplyButton = styled.button`
  margin: 0; min-height: var(--control-sm); padding: var(--space-1) var(--space-2); border: 1px solid var(--color-border-default);
  border-radius: var(--radius-sm); background: var(--color-bg-surface); color: var(--color-text-link); font: inherit; font-size: var(--text-caption); cursor: pointer;
  transition: background var(--duration-fast), border-color var(--duration-fast);
  &:hover { background: var(--color-brand-subtle); border-color: var(--color-text-link); }
  &:focus-visible { outline: 2px solid var(--color-focus-ring); outline-offset: 2px; }
`;
const ReplyArea = styled.div`grid-column: 1 / -1; margin-top: var(--space-2);`;
const CopyFeedback = styled.div`
  position: fixed; z-index: var(--z-toast); left: 50%; bottom: calc(var(--space-6) + env(safe-area-inset-bottom));
  transform: translateX(-50%); box-sizing: border-box; width: max-content; max-width: calc(100vw - var(--space-8));
  padding: var(--space-3) var(--space-4); border-radius: var(--radius-md); background: var(--color-bg-inverse);
  color: var(--color-text-on-inverse); font-family: var(--font-family-base); font-size: var(--text-body); line-height: var(--leading-body);
`;
function ChatUserMenu({ anchorRef, menuRef, label, onDismiss, children }: {
  anchorRef: { current: HTMLDivElement | null }; menuRef: { current: HTMLDivElement | null }; label: string; onDismiss: () => void; children: ReactNode;
}) {
  const [position, setPosition] = useState<{ left: number; top: number } | null>(null);
  const [actionTaken, setActionTaken] = useState(false);
  const actionCleanup = useRef<(() => void) | null>(null);
  const owner = anchorRef.current?.ownerDocument || document;
  const visibleDialogs = () => Array.from(owner.querySelectorAll('[role="dialog"][aria-modal="true"]'))
    .filter(dialog => !dialog.closest('[hidden], [aria-hidden="true"]'));
  useEffect(() => () => actionCleanup.current?.(), []);
  useEffect(() => {
    const anchor = anchorRef.current, menu = menuRef.current;
    if (!anchor || !menu) return;
    const rect = anchor.getBoundingClientRect(), window = owner.defaultView!;
    const below = rect.bottom + 8;
    setPosition({ left: Math.max(12, Math.min(rect.right - menu.offsetWidth, window.innerWidth - menu.offsetWidth - 12)),
      top: Math.max(12, below + menu.offsetHeight <= window.innerHeight - 12 ? below : rect.top - menu.offsetHeight - 8) });
    menu.querySelector<HTMLButtonElement>('button')?.focus();
    const dismiss = () => { if (!visibleDialogs().length) onDismiss(); };
    window.addEventListener('resize', dismiss); window.addEventListener('scroll', dismiss, true);
    return () => { window.removeEventListener('resize', dismiss); window.removeEventListener('scroll', dismiss, true); };
  }, [owner, anchorRef, menuRef, onDismiss]);
  return createPortal(<InlineMenu ref={menuRef} role="group" aria-label={label}
    onClickCapture={event => {
      const button = (event.target as HTMLElement).closest('button');
      if (!button || button.disabled) return;
      const previousDialogs = new Set(visibleDialogs());
      setActionTaken(true);
      const timer = window.setTimeout(() => {
        const opened = visibleDialogs().filter(dialog => !previousDialogs.has(dialog));
        if (!opened.length) { onDismiss(); return; }
        // Keep the action component mounted while its confirmation portal is open.
        const observer = new MutationObserver(() => {
          if (!opened.some(dialog => dialog.isConnected && !dialog.closest('[hidden], [aria-hidden="true"]'))) {
            observer.disconnect(); onDismiss();
          }
        });
        observer.observe(owner.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden', 'aria-hidden'] });
        actionCleanup.current = () => observer.disconnect();
      }, 0);
      actionCleanup.current = () => window.clearTimeout(timer);
    }} style={{ left: position?.left || 0, top: position?.top || 0, visibility: position && !actionTaken ? 'visible' : 'hidden' }}>{children}</InlineMenu>, owner.body);
}
const ChatTime = styled.time`
  display: inline-block; margin-left: var(--space-2); color: var(--color-text-secondary);
  font-size: var(--text-caption); font-weight: 400; white-space: nowrap; text-shadow: none;
  text-align: left; font-variant-numeric: tabular-nums;
`;
const AnsweredBadge = styled.span`
  display: inline-flex; align-items: center; height: calc(var(--space-4) + var(--space-3));
  margin: var(--space-2) 0 var(--space-1) var(--space-2);
  padding: 0 var(--space-2); border-radius: var(--radius-sm); background: var(--color-success-subtle);
  color: var(--color-success); font-family: var(--font-family-base); font-size: var(--text-caption);
  font-weight: 500; line-height: var(--leading-caption); white-space: nowrap; vertical-align: middle; text-shadow: none;
`;

const timeFormat = new Intl.DateTimeFormat('ko-KR', { timeZone: 'Asia/Seoul', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' });
const dateFormat = new Intl.DateTimeFormat('ko-KR', { timeZone: 'Asia/Seoul', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23' });
const messageOrder = (a: any, b: any) => {
  if (a.HistoryId && b.HistoryId) {
    const [aTime, aSequence] = a.HistoryId.split('-').map(Number);
    const [bTime, bSequence] = b.HistoryId.split('-').map(Number);
    return aTime - bTime || aSequence - bSequence;
  }
  return Date.parse(a.SendTime) - Date.parse(b.SendTime);
};
const graphemeSegmenter = (Intl as any).Segmenter ? new (Intl as any).Segmenter('ko', { granularity: 'grapheme' }) : null;
function highlightChatText(value: string | undefined, query: string): ReactNode {
  const text = value || '';
  if (!query) return text;
  const normalized = text.normalize('NFKC').toLocaleLowerCase();
  if (!normalized.includes(query)) return text;
  // Map normalized matches back to the original spelling, including full-width and composed characters.
  const offsets: { start: number; end: number }[] = [];
  if (graphemeSegmenter) {
    for (const { segment, index } of graphemeSegmenter.segment(text)) {
      const length = segment.normalize('NFKC').toLocaleLowerCase().length;
      for (let unit = 0; unit < length; unit++) offsets.push({ start: index, end: index + segment.length });
    }
  } else {
    let prefix = '';
    for (const character of text) {
      const start = prefix.length, previousLength = offsets.length;
      prefix += character;
      const length = prefix.normalize('NFKC').toLocaleLowerCase().length;
      if (length <= previousLength) {
        offsets.length = length;
        const previous = offsets[length - 1];
        if (previous) for (let unit = length - 1; unit >= 0 && offsets[unit].start === previous.start; unit--) offsets[unit].end = prefix.length;
      } else for (let unit = previousLength; unit < length; unit++) offsets.push({ start, end: prefix.length });
    }
  }
  const parts: ReactNode[] = [];
  let from = 0, cursor = 0;
  for (let match = normalized.indexOf(query, from); match !== -1; match = normalized.indexOf(query, from)) {
    const start = offsets[match]?.start, end = offsets[match + query.length - 1]?.end;
    from = match + query.length;
    if (start === undefined || end === undefined || end <= cursor) continue;
    const originalStart = Math.max(cursor, start);
    parts.push(text.slice(cursor, originalStart), <mark key={match} data-chat-search-text>{text.slice(originalStart, end)}</mark>);
    cursor = end;
  }
  parts.push(text.slice(cursor));
  return parts;
}



const ChatComponent = forwardRef(

  ({ mesage, all_visible, live_info, isAuthenticated = true, readOnly = false, adminView = false, renderUserActions, renderReply, answeredMessageIds, onPurchaseNotification, searchQuery = '', searchIndex = 0, onSearchMatches, hideForbiddenMessages = false, hideMutedMessages = false, showNicknameSeparator = true }: ChatComponentProps, ref) => {
    const notifyLive = useLiveNotice();
    const [messages, setMessages] = useState<any[]>([]);
    const [selectedMessage, setSelectedMessage] = useState<string | null>(null);
    const dismissUserMenu = useCallback(() => setSelectedMessage(null), []);
    const [replyMessage, setReplyMessage] = useState<string | null>(null);
    const [copyNotice, setCopyNotice] = useState<{ message: string; failed: boolean } | null>(null);
    const userActionsRef = useRef<HTMLDivElement>(null);
    const userMenuRef = useRef<HTMLDivElement>(null);
    const [historyLoading, setHistoryLoading] = useState(false);
    const { state: restrictions, acceptSocketState } = useChatRestrictions(live_info?.seq, adminView);
    // Use the moderation saved at send time; current restrictions must not recolor earlier chat.
    const isMutedChat = useCallback((message: any) => (message.Attributes?.type || 'user').toLowerCase() === 'user' &&
      message.Attributes?.moderation === 'muted', []);
    const visibleMessages = useMemo(() => {
      const closingNotices: number[] = [];
      return messages.filter(message => {
        if (message.Attributes?.type === 'system' && message.Content === '라이브 종료까지 5분 이내로 남았습니다. 예약된 종료 시간에 자동 종료됩니다.') {
          const time = new Date(message.SendTime).getTime();
          if (Number.isFinite(time)) {
            if (closingNotices.some(previous => Math.abs(time - previous) < 60000)) return false;
            closingNotices.push(time);
          }
        }
        if (!adminView) return true;
        if (hideForbiddenMessages && (message.Attributes?.moderation === 'forbidden-word'
          || forbiddenChatRanges(message.Content || '', message.Attributes?.forbiddenSpans).length > 0)) return false;
        return !(hideMutedMessages && isMutedChat(message));
      });
    }, [messages, adminView, hideForbiddenMessages, hideMutedMessages, isMutedChat]);
    useEffect(() => { setSelectedMessage(null); setReplyMessage(null); }, [hideForbiddenMessages, hideMutedMessages]);

    useEffect(() => {
      if (!copyNotice) return;
      const timer = window.setTimeout(() => setCopyNotice(null), copyNotice.failed ? 6000 : 2500);
      return () => window.clearTimeout(timer);
    }, [copyNotice]);
    useEffect(() => { setCopyNotice(null); }, [live_info?.seq, adminView]);
    const copyNickname = async (nickname: string) => {
      try {
        await navigator.clipboard.writeText(nickname);
        setCopyNotice({ message: '닉네임을 복사했습니다.', failed: false });
      } catch {
        setCopyNotice({ message: '닉네임을 복사하지 못했습니다. 브라우저의 클립보드 권한을 확인해주세요.', failed: true });
      }
    };

    const [newMessage, setNewMessage] = useState<string>(mesage);

    const ws = useRef<WebSocket | null>(null);

    const sentMessageIds = useRef<Set<string>>(new Set());

    const purchaseNotificationRef = useRef(onPurchaseNotification);
    const boxRef = useRef<HTMLDivElement | null>(null); // 스크롤 박스를 참조할 ref 생성

    const { ensureDetails } = useMemberDetails();
    const [connectionVersion, setConnectionVersion] = useState(0);
    const canSend = useRef(false);
    const sending = useRef(false);
    const pendingSend = useRef<{ content: string; done: (sent: boolean) => void } | null>(null);
    useEffect(() => () => { pendingSend.current?.done(false); pendingSend.current = null; }, [live_info?.seq, isAuthenticated]);
    const isAtBottom = useRef(true); // 스크롤이 맨 아래에 있는지 여부
    const normalizedSearch = adminView ? searchQuery.trim().normalize('NFKC').toLocaleLowerCase() : '';
    const searchMatches = useMemo(() => normalizedSearch ? visibleMessages.flatMap((message, index) => {
      const nickname = message.Sender?.Attributes?.displayName || '';
      const content = `${nickname}\n${message.Content || ''}`.normalize('NFKC').toLocaleLowerCase();
      return content.includes(normalizedSearch) ? [index] : [];
    }) : [], [visibleMessages, normalizedSearch]);
    const searchMatchSet = useMemo(() => new Set(searchMatches), [searchMatches]);
    const activeSearchIndex = searchMatches[Math.min(Math.max(searchIndex, 0), searchMatches.length - 1)];
    const activeSearchKey = activeSearchIndex === undefined ? undefined : (visibleMessages[activeSearchIndex].id || String(activeSearchIndex));
    useEffect(() => { onSearchMatches?.(searchMatches.length); }, [searchMatches.length, onSearchMatches]);
    useLayoutEffect(() => {
      const box = boxRef.current;
      const match = box?.querySelector<HTMLElement>('[data-chat-search-active="true"]');
      if (!box || !match) return;
      box.scrollTo({ top: Math.max(0, box.scrollTop + match.getBoundingClientRect().top - box.getBoundingClientRect().top - (box.clientHeight - match.offsetHeight) / 2), behavior: 'auto' });
    }, [normalizedSearch, activeSearchKey]);

    useEffect(() => {
      if (!selectedMessage) return;
      const closeOutside = (event: PointerEvent) => {
        const target = event.target as HTMLElement | null;
        if (target?.closest?.('[data-chat-menu-trigger]') || target?.closest?.('[role="dialog"][aria-modal="true"]:not([hidden])')) return;
        if (!userActionsRef.current?.contains(event.target as Node) && !userMenuRef.current?.contains(event.target as Node)) setSelectedMessage(null);
      };
      const closeOnEscape = (event: KeyboardEvent) => {
        if (event.key !== 'Escape' || Array.from(document.querySelectorAll('[role="dialog"][aria-modal="true"]')).some(dialog => !dialog.closest('[hidden], [aria-hidden="true"]'))) return;
        userActionsRef.current?.querySelector('button')?.focus();
        setSelectedMessage(null);
      };
      document.addEventListener('pointerdown', closeOutside);
      document.addEventListener('keydown', closeOnEscape);
      return () => {
        document.removeEventListener('pointerdown', closeOutside);
        document.removeEventListener('keydown', closeOnEscape);
      };
    }, [selectedMessage]);



    useImperativeHandle(ref, () => ({

      sendMessage,

    }));



    useEffect(() => {

      setNewMessage(mesage); // 새로운 mesage가 전달되면 상태 업데이트

    }, [mesage]);

    useEffect(() => {
      purchaseNotificationRef.current = onPurchaseNotification;
    }, [onPurchaseNotification]);


    useEffect(() => {

      if (!live_info?.seq || !live_info.channel_name) return;


      let chatWebSocketUrl =

        "wss://edge.ivschat.ap-northeast-2.amazonaws.com";



      // 의도적 종료(언마운트/토큰 변경)와 비정상 끊김을 구분하기 위한 플래그

      setMessages([]);
      setSelectedMessage(null);
      setReplyMessage(null);
      setHistoryLoading(false);
      sentMessageIds.current.clear();
      let closedIntentionally = false;

      let reconnectTimer: ReturnType<typeof setTimeout> | null = null;
      let connecting = false;

      let attempts = 0;



      const pushSystem = (content: string, connectionNotice = false) =>

        setMessages((prevMessages) => [

          ...(adminView ? prevMessages.filter(message => !connectionNotice || !message.connectionNotice)
            : prevMessages.filter(message => !connectionNotice || !message.connectionNotice).slice(-199)),

          {

            Attributes: { type: "System" },

            Content: content,
            SendTime: new Date().toISOString(),
            connectionNotice,

            Sender: {

              UserId: "System",

              Attributes: { displayName: "System" },

            },

          },

        ]);



      const scheduleReconnect = () => {
        if (closedIntentionally || reconnectTimer) return;
        attempts += 1;
        const ceiling = Math.min(1000 * 2 ** Math.min(attempts - 1, 3), 5000);
        reconnectTimer = setTimeout(() => {
          reconnectTimer = null;
          void connect();
        }, ceiling / 2 + Math.random() * ceiling / 2);
      };

      const connect = async () => {
        if (closedIntentionally || connecting) return;
        connecting = true;
        // IVS tokens are single-use, so every reconnection needs a fresh token.
        let token: string;
        try {
          const res = isAuthenticated
            ? await api.post(url.Communication_url.createChatToken, { channelName: live_info.channel_name, liveSeq: live_info.seq }, { timeout: 10000, headers: { 'Content-Type': 'application/json' } })
            : await axios.post(url.Communication_url.guest_chat_token, { liveSeq: live_info.seq }, { timeout: 10000 });
          token = res.data.token;
          canSend.current = res.data.canSend !== false;
          chatWebSocketUrl = res.data.endpoint || "wss://edge.ivschat.ap-northeast-2.amazonaws.com";
          if (!token) throw new Error('Missing chat token');
        } catch {
          if (!closedIntentionally && attempts === 0) pushSystem('채팅을 연결하지 못했습니다. 다시 연결 중입니다.', true);
          scheduleReconnect();
          return;
        } finally {
          connecting = false;
        }
        if (closedIntentionally) return;
        const Decompressor = (window as any).DecompressionStream as undefined | (new (format: string) => TransformStream<Uint8Array, Uint8Array>);
        if (chatWebSocketUrl !== "wss://edge.ivschat.ap-northeast-2.amazonaws.com" && Decompressor) {
          const endpoint = new URL(chatWebSocketUrl); endpoint.searchParams.set("encoding", "gzip"); chatWebSocketUrl = endpoint.href;
        }
        const socket = new WebSocket(chatEndpoint(chatWebSocketUrl), token);
        socket.binaryType = "arraybuffer";
        let decodeChain = Promise.resolve();
        ws.current = socket;



        socket.onopen = () => {
          if (closedIntentionally || ws.current !== socket) return;

          setMessages(previous => previous.filter(message => !message.connectionNotice));
          attempts = 0; // 재연결 성공 시 백오프 리셋
          const pending = pendingSend.current;
          if (pending && canSend.current) {
            pendingSend.current = null;
            socket.send(JSON.stringify({ action: "SEND_MESSAGE", content: pending.content, Attributes: { type: "user" } }));
            setNewMessage(current => current === pending.content ? "" : current);
            pending.done(true);
          }
        };



        socket.onmessage = (event) => {
          decodeChain = decodeChain.then(async () => {
          if (closedIntentionally) return;
          let data: any;
          try {
            if (event.data instanceof ArrayBuffer) {
              const bytes = new Uint8Array(event.data);
              if (new TextDecoder().decode(bytes.slice(0, 4)) !== "FBRT") return;
              if (!Decompressor || bytes.length < 8) throw new Error('Unsupported chat encoding');
              const stream = new Blob([event.data.slice(8)]).stream().pipeThrough(new Decompressor("gzip"));
              data = JSON.parse(await new Response(stream).text());
            } else data = JSON.parse(event.data.toString());
          } catch { pushSystem("채팅 메시지를 읽지 못했습니다. 다시 연결합니다.", true); socket.close(); return; }
          if (closedIntentionally || ws.current !== socket) return;
          if (acceptSocketState(data)) return;
          if (data.type === "ready") {
            if (adminView) {
              setHistoryLoading(true);
              socket.send(JSON.stringify({ action: 'GET_HISTORY', requestId: 'chat-history', after: '0-0' }));
            }
            return;
          }
          if (data.type === "ack") return;
          if (data.type === "error") {
            if (data.requestId === 'chat-history') {
              setHistoryLoading(false); pushSystem('이전 채팅을 불러오지 못했습니다. 다시 연결하면 재시도합니다.');
            } else pushSystem(data.message || "채팅 전송에 실패했습니다.");
            return;
          }
          const history = data.type === 'history';
          const incoming = data.type === "batch" || history ? data.messages : [data];
          const chat: any[] = [];
          for (const message of incoming) {
            const messageType = (message.Attributes?.type || "").toLowerCase();
            const isSystem = messageType !== "buy" && (messageType === "system" || (message.Sender?.UserId || "").toLowerCase() === "system");
            // 이전 채팅 서버가 보내는 연결 성공 안내도 표시하지 않는다.
            if (isSystem && /^(?:라이브\s*)?채팅\s*서버에\s*연결되었습니다\.?$/.test(message.Content?.trim() || "")) continue;
            if (!history && messageType === "buy" && purchaseNotificationRef.current) {
              purchaseNotificationRef.current(message.Content);
            } else if (message.Content && !sentMessageIds.current.has(message.id)) {
              if (message.id) sentMessageIds.current.add(message.id);
              chat.push({ ...message, SendTime: message.SendTime || new Date().toISOString() });
            }
          }
          if (!adminView && sentMessageIds.current.size > 2000) sentMessageIds.current.clear();
          if (chat.length) setMessages(previous => adminView ? [...previous, ...chat].sort(messageOrder) : [...previous, ...chat].slice(-200));
          if (history) {
            if (data.hasMore && data.cursor && data.snapshot) {
              socket.send(JSON.stringify({ action: 'GET_HISTORY', requestId: 'chat-history', after: data.cursor, until: data.snapshot }));
            } else setHistoryLoading(false);
          }
          }).catch(() => socket.close());
        };
        socket.onerror = () => {

          // onclose가 뒤이어 호출되므로 재연결은 onclose에서 일괄 처리

        };



        socket.onclose = () => {

          if (closedIntentionally || ws.current !== socket) return;
          ws.current = null;

          if (attempts === 0) pushSystem("채팅 연결이 끊겼습니다. 재연결 중...", true);

          scheduleReconnect();
        };

      };



      connect();



      return () => {

        closedIntentionally = true;

        if (reconnectTimer) clearTimeout(reconnectTimer);

        ws.current?.close();
        ws.current = null;
      };
    }, [live_info?.seq, live_info?.channel_name, isAuthenticated, connectionVersion, adminView, acceptSocketState]);


    const handleScroll = () => {

      if (boxRef.current) {

        const { scrollTop, scrollHeight, clientHeight } = boxRef.current;

        isAtBottom.current = scrollHeight - scrollTop - clientHeight <= 8;

      }

    };



    useLayoutEffect(() => {

      if (adminView && !normalizedSearch && isAtBottom.current && boxRef.current) {

        boxRef.current.scrollTo({

          top: boxRef.current.scrollHeight,

          behavior: "auto",

        });

      }

    }, [visibleMessages]); // 표시할 메시지가 변경될 때마다 실행

    useLayoutEffect(() => {
      if (!adminView && boxRef.current) fitChatViewport(boxRef.current, isAtBottom.current, {
        rowSelector: ':scope > div', maxHeight: boxRef.current.parentElement?.clientHeight,
      });
    }, [messages, all_visible, adminView]);

    useEffect(() => {
      if (adminView) return;
      const resize = () => {
        if (boxRef.current) fitChatViewport(boxRef.current, isAtBottom.current, {
          rowSelector: ':scope > div', maxHeight: boxRef.current.parentElement?.clientHeight,
        });
      };
      window.addEventListener('resize', resize);
      return () => window.removeEventListener('resize', resize);
    }, [adminView, isAtBottom]);



    const sendMessage = async (): Promise<boolean> => {
      if (readOnly || !isAuthenticated || sending.current || !newMessage.trim()) return false;
      const content = newMessage;
      sending.current = true;
      try {
        const result = await ensureDetails('nickname');
        if (!result) return false;
        if (result === 'updated' || !canSend.current) {
          return await new Promise<boolean>(done => {
            const timeout = window.setTimeout(() => { pendingSend.current = null; done(false); }, 15000);
            pendingSend.current = { content, done: sent => { window.clearTimeout(timeout); done(sent); } };
            setConnectionVersion(version => version + 1);
          });
        }
        if (!ws.current || ws.current.readyState !== WebSocket.OPEN) return false;
        ws.current.send(JSON.stringify({ action: "SEND_MESSAGE", content, Attributes: { type: "user" } }));
        setNewMessage(current => current === content ? "" : current);
        return true;
      } catch (error) {
        notifyLive(error instanceof Error ? error.message : '회원정보를 확인하지 못했습니다. 다시 시도해주세요.');
        return false;
      } finally { sending.current = false; }
    };

    const getChatType = (msg: any) => {

      const userId = (msg.Sender?.UserId || "").toLowerCase();
      const type = (msg.Attributes?.type || "").toLowerCase();
      if (type === 'coupon') return 'coupon';

      // 구매 알림은 System 계정에서 오므로 일반 시스템 메시지보다 먼저 구분한다.
      if (type === "buy") {
        return "buy";
      }
      if (userId === "system" || type === "system") {
        return "system";
      }
      if (

        userId === "master" ||

        userId === "linkcampus" ||

        userId === "testy" ||

        type === "manage"

      ) {

        return "manage";

      }

      return "user";

    };



    return (

      <Box $admin={adminView} ref={boxRef} onScroll={handleScroll} role={adminView ? "log" : undefined}
        aria-label={adminView ? "실시간 채팅 메시지" : undefined} aria-live={adminView ? "polite" : undefined}>
        {adminView && copyNotice && createPortal(<CopyFeedback as={LiveFeedback} fallbackAs="div" role={copyNotice.failed ? 'alert' : 'status'}>
          {copyNotice.message}
        </CopyFeedback>, boxRef.current?.ownerDocument.body || document.body)}
        {adminView && historyLoading && <p role="status">이전 채팅을 불러오는 중입니다.</p>}

        {visibleMessages.map((message, index) => {

          const chatType = getChatType(message);
          const showSender = !(adminView && chatType === "manage") && !['buy', 'coupon'].includes(chatType) && !(chatType === "system" && /^라이브(?:\s|$)/.test(message.Content?.trim() || ""));
          const nickname = message.Sender?.Attributes?.displayName;
          const muted = adminView && isMutedChat(message);
          const forbidden = adminView && (message.Attributes?.moderation === 'forbidden-word'
            || forbiddenChatRanges(message.Content || '', message.Attributes?.forbiddenSpans).length > 0);
          const userId = message.Sender?.UserId;
          const selectable = adminView && (renderUserActions || renderReply) && chatType === "user" && nickname && userId;
          const messageKey = message.id || String(index);
          const menuOpen = selectedMessage === messageKey;
          const sentAt = new Date(message.SendTime);
          const toggleMenu = () => setSelectedMessage(current => current === messageKey ? null : messageKey);
          const messageBody = <>
            {showSender && (selectable ? <UserButton type="button" data-chat-name data-chat-menu-trigger
              data-chat-name-separator={showNicknameSeparator || undefined} data-chat-type={chatType} data-chat-name-muted={muted || undefined} data-chat-name-forbidden={forbidden || undefined}
              aria-expanded={menuOpen} aria-label={`${nickname} 사용자 관리`} onClick={toggleMenu}>
              {highlightChatText(nickname, normalizedSearch)}
            </UserButton> : <NameSpan $chatType={chatType} data-chat-name
              data-chat-name-separator={showNicknameSeparator && Boolean(chatType === 'system' || nickname)} data-chat-type={chatType} data-chat-name-muted={muted || undefined} data-chat-name-forbidden={forbidden || undefined}>
              {highlightChatText(chatType === 'system' ? '라이브' : nickname, normalizedSearch)}
            </NameSpan>)}
            <ContentSpan $chatType={chatType} data-chat-content data-chat-has-sender={showSender || undefined}
              data-chat-type={chatType} data-chat-muted={muted || undefined} data-chat-content-forbidden={forbidden || undefined}>
              <ChatModeratedText content={(chatType === 'system' ? message.Content?.replace(/채팅서버/g, '채팅 서버') : message.Content) || ''}
                strikeWholeMessage={forbidden} spans={adminView ? message.Attributes?.forbiddenSpans : undefined} renderText={text => highlightChatText(text, normalizedSearch)} />
            </ContentSpan>
            {adminView && chatType === 'user' && answeredMessageIds?.has(message.id) && <AnsweredBadge data-chat-answer-status>답변 완료</AnsweredBadge>}
          </>;

          return (

            <ChatBox key={messageKey} data-chat-message data-chat-search-match={searchMatchSet.has(index) || undefined}
              data-chat-search-active={normalizedSearch && index === activeSearchIndex ? true : undefined}
              data-chat-side={adminView && chatType === "manage" ? "right" : undefined}
              data-chat-restricted={muted || undefined}>

              {all_visible && (

                <MessageLine data-chat-line>
                  {adminView ? <><div data-chat-body>{messageBody}</div>
                    <ChatMeta data-chat-meta ref={menuOpen ? userActionsRef : undefined}>
                      {Number.isFinite(sentAt.getTime()) && <ChatTime dateTime={sentAt.toISOString()} title={dateFormat.format(sentAt)}>
                        {timeFormat.format(sentAt)}
                      </ChatTime>}
                      {selectable && <OverflowButton type="button" data-chat-menu-trigger aria-label={`${nickname} 채팅 관리 메뉴`}
                        aria-expanded={menuOpen} onClick={toggleMenu}>
                        <svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="5" r="1.5" /><circle cx="12" cy="12" r="1.5" /><circle cx="12" cy="19" r="1.5" /></svg>
                      </OverflowButton>}
                    </ChatMeta>
                    {menuOpen && <ChatUserMenu anchorRef={userActionsRef} menuRef={userMenuRef} label={`${nickname} 사용자 관리`} onDismiss={dismissUserMenu}>
                      <ReplyButton type="button" data-chat-action="copy" aria-label={`${nickname} 닉네임 복사`} onClick={() => { setSelectedMessage(null); void copyNickname(nickname); }}>닉네임 복사</ReplyButton>
                      {renderReply && message.id && <ReplyButton type="button" data-chat-action="reply" aria-label={`${nickname} 채팅에 답변`} onClick={() => { setSelectedMessage(null); setReplyMessage(messageKey); }}>답변</ReplyButton>}
                      {renderUserActions?.({ userId, nickname, restriction: restrictions?.ready ? { blocked: restrictions.banned.has(nickname), muted: restrictions.muted.has(nickname) } : null })}
                    </ChatUserMenu>}
                  </> : messageBody}
                  {replyMessage === messageKey && renderReply && <ReplyArea>{renderReply({ messageId: message.id, nickname: nickname || '고객', content: message.Content,
                    private: message.Attributes?.moderation === 'muted' }, () => setReplyMessage(null))}</ReplyArea>}

                </MessageLine>

              )}

            </ChatBox>

          );

        })}

      </Box>

    );

  }

);



export default ChatComponent;
